import { css } from "@emotion/core";
import { color, fontWeight } from "../../constants/commons";

export const statusBarStyle = css`
  .ant-steps-item-process
    .ant-steps-item-icon
    > .ant-steps-icon
    .ant-steps-icon-dot {
    background: ${color.black};
    top: 1px;
  }

  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    background-color: ${color.black};
  }
  .ant-steps-item-finish
    .ant-steps-item-icon
    > .ant-steps-icon
    .ant-steps-icon-dot {
    top: 1px;
  }

  .ant-steps-item-wait
    .ant-steps-item-icon
    > .ant-steps-icon
    .ant-steps-icon-dot {
    top: 1px;
  }

  .ant-steps-item-wait {
    .ant-steps-item-title {
      color: ${color.lightishGray} !important;
    }
  }
  .ant-steps-item-finish
    .ant-steps-item-icon
    > .ant-steps-icon
    .ant-steps-icon-dot {
    background: ${color.black};
  }
  .ant-steps-item-title {
    color: ${color.black};
    // Intentionally added this value in pixel. Not able to override antd's style with em values
    font-size: 12px;
    font-weight: ${fontWeight.bold};
    text-transform: uppercase;
  }

  .ant-steps {
    overflow: scroll;
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
    overflow: -moz-scrollbars-none; /* For Older versions of firefox */
  }
  .ant-steps::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  .ant-steps
    .ant-steps-item:not(.ant-steps-item-active)
    > .ant-steps-item-container[role="button"]:hover
    .ant-steps-item-title,
  .ant-steps
    .ant-steps-item:not(.ant-steps-item-active)
    > .ant-steps-item-container[role="button"]:hover
    .ant-steps-item-subtitle,
  .ant-steps
    .ant-steps-item:not(.ant-steps-item-active)
    > .ant-steps-item-container[role="button"]:hover
    .ant-steps-item-description {
    color: ${color.black};
  }
`;
